import { render, staticRenderFns } from "./customFieldDisplayConfiguration.vue?vue&type=template&id=b41b93d4&"
import script from "./customFieldDisplayConfiguration.vue?vue&type=script&lang=js&"
export * from "./customFieldDisplayConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41b93d4')) {
      api.createRecord('b41b93d4', component.options)
    } else {
      api.reload('b41b93d4', component.options)
    }
    module.hot.accept("./customFieldDisplayConfiguration.vue?vue&type=template&id=b41b93d4&", function () {
      api.rerender('b41b93d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/customFieldDisplayConfiguration/customFieldDisplayConfiguration.vue"
export default component.exports